const testMachineData = [
    {
        machineNo: 1,
        machineName: '액상 판매기 1',
        machineAffiliation: '관저점',
        machineWork: 'online',
        machineInventoryRatio: 98,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
    {
        machineNo: 2,
        machineName: '액상 판매기 2',
        machineAffiliation: '관저점',
        machineWork: 'offline',
        machineInventoryRatio: 88,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
    {
        machineNo: 3,
        machineName: '액상 판매기 3',
        machineAffiliation: '관저점',
        machineWork: 'error',
        machineInventoryRatio: 78,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
    {
        machineNo: 4,
        machineName: '액상 판매기 1',
        machineAffiliation: '도안점',
        machineWork: 'online',
        machineInventoryRatio: 98,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
    {
        machineNo: 5,
        machineName: '액상 판매기 2',
        machineAffiliation: '도안점',
        machineWork: 'offline',
        machineInventoryRatio: 88,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
    {
        machineNo: 6,
        machineName: '액상 판매기 3',
        machineAffiliation: '도안점',
        machineWork: 'error',
        machineInventoryRatio: 78,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
    {
        machineNo: 7,
        machineName: '액상 판매기 1',
        machineAffiliation: '둔산점',
        machineWork: 'online',
        machineInventoryRatio: 98,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
    {
        machineNo: 8,
        machineName: '액상 판매기 2',
        machineAffiliation: '둔산점',
        machineWork: 'offline',
        machineInventoryRatio: 88,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
    {
        machineNo: 9,
        machineName: '액상 판매기 3',
        machineAffiliation: '둔산점',
        machineWork: 'error',
        machineInventoryRatio: 78,
        machineTotalSales: 100000000,
        machineSaleProductsCnt: 1000,
    },
];

export default testMachineData;